import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, Table } from 'antd'
// import {DropOption} from '../../../components'

 
const { confirm } = Modal

const ViewModal = (campaignProps) => {
 
   
  const { modalVisible, handleCancel , info} = campaignProps 
  return (

    <Modal
      title="Training Details"
      visible={modalVisible}  
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Close</Button> 
      ]}
    >
      {/* {Object.keys(info.credentials || {})
        .filter(key => info.credentials[key])
        .map(key => {
            return (
                <div className="pad-btm">
                    <strong className="text-main">{key}</strong>
                    <br/>
                    {info.credentials[key]}
                </div>
            );
        })} */}
    
    </Modal> 
  ) 
}

export default ViewModal
